import { MagnifyMinusOutlineIcon } from './MagnifyMinusOutlineIcon';

/**
 * author: Google
 * id 9E259697-7035-4E17-82D6-431C74215E67
 * name magnify-minus-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-minus-outline.svg
 * tags
 * - Geographic Information System 
 */
export const SearchMinusOutlineIcon = MagnifyMinusOutlineIcon;
export default SearchMinusOutlineIcon